import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  id: "UI",
  tabindex: "-1"
}
const _hoisted_3 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_testing = _resolveComponent("testing")!
  const _component_emulator = _resolveComponent("emulator")!
  const _component_icon = _resolveComponent("icon")!

  return (_ctx.parameters.game)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.popup)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["popup", { error: _ctx.popupError }])
            }, _toDisplayString(_ctx.popupMessage), 3))
          : _createCommentVNode("", true),
        (_ctx.showUI)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showBar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("img", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.home && _ctx.home(...args))),
                      class: "logo",
                      alt: "Kraken Logo",
                      src: _imports_0
                    }),
                    _withDirectives(_createElementVNode("div", null, [
                      _createVNode(_component_testing, {
                        onPopout: _ctx.popout,
                        onSendSuccess: _ctx.sendSuccess,
                        onSendFail: _ctx.sendFail,
                        onClearSuccess: _ctx.clearSuccess,
                        onClearFail: _ctx.clearFail,
                        onFreeRoundsSuccess: _ctx.freeRoundsSuccess,
                        onFreeRoundsFail: _ctx.freeRoundsFail,
                        onAutoCompleteSuccess: _ctx.autoCompleteSuccess,
                        onAutoCompleteFail: _ctx.autoCompleteFail,
                        onLaunchEmulator: _ctx.launchEmulator
                      }, null, 8, ["onPopout", "onSendSuccess", "onSendFail", "onClearSuccess", "onClearFail", "onFreeRoundsSuccess", "onFreeRoundsFail", "onAutoCompleteSuccess", "onAutoCompleteFail", "onLaunchEmulator"])
                    ], 512), [
                      [_vShow, !_ctx.showEmulator]
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createVNode(_component_emulator, {
                        frameKey: _ctx.frameKey,
                        onBackToGame: _ctx.closeEmulator,
                        onUpdateBalanceFail: _ctx.failedToUpdateBalance
                      }, null, 8, ["frameKey", "onBackToGame", "onUpdateBalanceFail"])
                    ], 512), [
                      [_vShow, _ctx.showEmulator]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_icon, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBar = !_ctx.showBar)),
                icon: _ctx.sideBarIcon,
                class: _normalizeClass(["sidebar-button", {'left': !_ctx.showBar}])
              }, null, 8, ["icon", "class"]),
              _createVNode(_component_icon, {
                onClick: _ctx.onLockBarChange,
                icon: _ctx.lockBarIcon,
                class: _normalizeClass(["sidebar-button lockbar", {'left': !_ctx.showBar}])
              }, null, 8, ["onClick", "icon", "class"]),
              _createVNode(_component_icon, {
                onClick: _ctx.refreshGame,
                icon: "refresh",
                class: "sidebar-button refresh"
              }, null, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.gameUrl)
          ? (_openBlock(), _createElementBlock("iframe", {
              id: "gameFrame",
              key: `${_ctx.frameKey}`,
              src: _ctx.gameUrl,
              class: _normalizeClass(["game-frame", {'gameFull': !_ctx.showBar || !_ctx.showUI, 'unlocked': !_ctx.lockBar }]),
              allow: "fullscreen; local-network-access *"
            }, null, 10, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}